import { createContext } from 'react';
import { IPlatesContext } from './types';

export const PlatesContext = createContext({} as IPlatesContext);
